// src/utils/hooks/useInvalidateCache.ts
import { useQueryClient } from "@tanstack/react-query";

/**
 * Hook to invalidate React Query caches after data mutations.
 * Use this instead of window.location.reload() for better UX.
 */
export function useInvalidateCache() {
  const queryClient = useQueryClient();

  const invalidateClients = async () => {
    await queryClient.invalidateQueries({ queryKey: ['clients'] });
    await queryClient.invalidateQueries({ queryKey: ['recentClients'] });
    await queryClient.invalidateQueries({ queryKey: ['dashboardCards'] });
  };

  const invalidateProducts = async () => {
    await queryClient.invalidateQueries({ queryKey: ['products'] });
    await queryClient.invalidateQueries({ queryKey: ['dashboardCards'] });
    await queryClient.invalidateQueries({ queryKey: ['analytics'] });
  };

  const invalidateAffiliates = async () => {
    await queryClient.invalidateQueries({ queryKey: ['affiliates'] });
    await queryClient.invalidateQueries({ queryKey: ['dashboardCards'] });
  };

  const invalidateSubscriptions = async () => {
    await queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
    await queryClient.invalidateQueries({ queryKey: ['dashboardCards'] });
    await queryClient.invalidateQueries({ queryKey: ['monthlyRevenue'] });
    await queryClient.invalidateQueries({ queryKey: ['analytics'] });
    await queryClient.invalidateQueries({ queryKey: ['recentClients'] });
  };

  const invalidateBookings = async () => {
    await queryClient.invalidateQueries({ queryKey: ['bookings'] });
    await queryClient.invalidateQueries({ queryKey: ['bookableProducts'] });
  };

  const invalidateNotifications = async () => {
    await queryClient.invalidateQueries({ queryKey: ['notificationTemplates'] });
    await queryClient.invalidateQueries({ queryKey: ['notificationCounts'] });
  };

  const invalidateCoworking = async () => {
    await queryClient.invalidateQueries({ queryKey: ['coworkingData'] });
    await queryClient.invalidateQueries({ queryKey: ['coworkingUsers'] });
  };

  const invalidateAll = async () => {
    await queryClient.invalidateQueries();
  };

  return {
    invalidateClients,
    invalidateProducts,
    invalidateAffiliates,
    invalidateSubscriptions,
    invalidateBookings,
    invalidateNotifications,
    invalidateCoworking,
    invalidateAll,
  };
}

